import { render, staticRenderFns } from "./addRowComponentWithRangeRiskScore.vue?vue&type=template&id=4af818a4"
import script from "./addRowComponentWithRangeRiskScore.vue?vue&type=script&lang=js"
export * from "./addRowComponentWithRangeRiskScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports